import { Controller } from "@hotwired/stimulus";

// Remove: removes the controller's element from the DOM. Wire a trigger inside
// it to the `remove` action — e.g. a dismiss button on a flash message:
//
//   <div data-controller="remove">
//     <button data-action="remove#remove">…</button>
//   </div>
export default class extends Controller {
  remove() {
    this.element.remove();
  }
}
